var React = require('react');

function CompareX (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z","fill":"#828282","key":0}),React.createElement("path",{"d":"M23 10.41L21.59 9L16 14.59L10.41 9L9 10.41L14.59 16L9 21.59L10.41 23L16 17.41L21.59 23L23 21.59L17.41 16L23 10.41Z","fill":"white","key":1})]);
}

CompareX.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = CompareX;

CompareX.default = CompareX;
